/* eslint-disable @typescript-eslint/no-explicit-any */
import { __awaiter } from "tslib";
import { fetchAuthSession } from "@aws-amplify/core";
import { parseCognitoClaimsForFe, } from "./ICognitoEventClaims";
import { confirmResetPassword, resetPassword } from "aws-amplify/auth";
import { confirmSignIn, fetchMFAPreference, getCurrentUser, setUpTOTP, signIn, signOut, updateMFAPreference, updatePassword, verifyTOTPSetup, } from "@aws-amplify/auth";
import { getPreferencesValue, setPreferencesKeyAndValue } from "@tedivo/tedivo-preferences";
import { Amplify } from "aws-amplify";
import { errorTracking } from "../tracking/errorTracking";
import goSquared from "../tracking/goSquared";
const TypedTvdAwsCognitoEventTarget = EventTarget;
export const FEDERATION_PROVIDERS = {
    Microsoft: "MicrosfotEntraIdSaml",
    Google: "",
};
/**
 * Class for AWSCognito API calls using AWS Amplify
 */
class TvdAwsCognito extends TypedTvdAwsCognitoEventTarget {
    get isMfaEnabled() {
        return this._mfaEnabled;
    }
    constructor() {
        super();
        this.currentCognitoSession = undefined;
        this.currentEmail = undefined;
        this.previousEmail = undefined;
        this._cognitoEventClaims = undefined;
        this._currentOrgSecurityData = undefined;
        this._userEditableDetails = {
            name: "",
            familyName: "",
            email: "",
        };
        this.jwtToken = undefined;
        this.accessTokenInternal = undefined;
        this.refreshTokenState = "idle";
        this.tempAcceptsMarketingMails = false;
        this.orgUsersBySub = undefined;
        this.previouslyLoggedIn = false;
        this._mfaEnabled = undefined;
        this.setMfaFlagAsDisabled = () => {
            this._mfaEnabled = undefined;
        };
        this.configUserPoolId = process.env.NX_PUBLIC_USER_POOL_ID || "";
        this.configClientId = process.env.NX_PUBLIC_USER_APP_CLIENT_ID || "";
        this.changeCurrentOrganization = (orgId) => {
            var _a, _b;
            if (orgId === ((_a = this._currentOrgSecurityData) === null || _a === void 0 ? void 0 : _a.orgId))
                return false;
            const orgRel = (_b = this._cognitoEventClaims) === null || _b === void 0 ? void 0 : _b.organizations.find((o) => o.orgId === orgId && o.uEnabled === "1");
            if (orgRel) {
                this._currentOrgSecurityData = orgRel;
                window.setTimeout(() => {
                    this.dispatchEvent(new CustomEvent("userDataRetrieved", { detail: orgRel }));
                }, 0);
                return true;
            }
            else {
                console.error("Unable to set invalid organization", orgId);
                return false;
            }
        };
        this.associateMfaDevice = ({ associateSecretCode, onFailure, }) => {
            setUpTOTP()
                .then((result) => {
                associateSecretCode(result.sharedSecret);
            })
                .catch((err) => {
                onFailure(err);
            });
            return true;
        };
        /**
         * This is called when the user has entered the MFA code for the first time and we need to verify it
         * @param code
         * @returns
         */
        this.verifyTopTCodeOnly = (code) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield verifyTOTPSetup({ code });
                return true;
            }
            catch (error) {
                console.log(error);
                return false;
            }
        });
        this.verifyTopTCode = (code) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            try {
                yield confirmSignIn({ challengeResponse: code });
                const session = yield fetchAuthSession();
                this.currentCognitoSession = session;
                this.jwtToken = (_b = (_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken) === null || _b === void 0 ? void 0 : _b.toString();
                this.accessTokenInternal = (_d = (_c = session.tokens) === null || _c === void 0 ? void 0 : _c.accessToken) === null || _d === void 0 ? void 0 : _d.toString();
                const proccessed = this.processCognitoSessionClaimsForFE((_e = session.tokens) === null || _e === void 0 ? void 0 : _e.idToken);
                if (proccessed === "OK") {
                    this.dispatchEvent(new CustomEvent("authenticationChanged", {
                        detail: { isLoggedIn: true },
                    }));
                    return {
                        code: "ok",
                        idToken: this.jwtToken,
                        accessToken: this.accessTokenInternal,
                    };
                }
                else {
                    return {
                        code: "failure",
                        error: { message: "Failed to process user data" },
                    };
                }
            }
            catch (error) {
                return { code: "failure", error };
            }
        });
        this._onSuccess = () => (session) => {
            return new Promise((resolve) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                this.currentEmail = (_b = (_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken) === null || _b === void 0 ? void 0 : _b.payload.email;
                this.previousEmail = this.currentEmail;
                this.currentCognitoSession = session;
                const accessToken = (_d = (_c = session.tokens) === null || _c === void 0 ? void 0 : _c.accessToken) === null || _d === void 0 ? void 0 : _d.toString();
                const idToken = (_f = (_e = session.tokens) === null || _e === void 0 ? void 0 : _e.idToken) === null || _f === void 0 ? void 0 : _f.toString();
                /* Use the idToken for Logins Map when Federating User Pools with identity pools or when passing through an Authorization Header to an API Gateway Authorizer */
                this.jwtToken = idToken;
                this.accessTokenInternal = (_h = (_g = session.tokens) === null || _g === void 0 ? void 0 : _g.accessToken) === null || _h === void 0 ? void 0 : _h.toString();
                const proccessed = this.processCognitoSessionClaimsForFE((_j = session.tokens) === null || _j === void 0 ? void 0 : _j.idToken);
                if (proccessed === "OK") {
                    this.dispatchEvent(new CustomEvent("authenticationChanged", {
                        detail: { isLoggedIn: true },
                    }));
                    if (!this.isUsingFederatedIdentity())
                        this.getMfaOptions();
                    resolve({ code: "ok", accessToken, idToken });
                }
                else if (proccessed === "FAIL") {
                    this.setMfaFlagAsDisabled();
                    this.dispatchEvent(new CustomEvent("authenticationChanged", {
                        detail: { isLoggedIn: false },
                    }));
                    resolve({ code: "failure", error: "Failed to compose user data" });
                }
                else {
                    this.dispatchEvent(new CustomEvent("authenticationChanged", {
                        detail: { isLoggedIn: true },
                    }));
                    resolve({ code: "failure", error: "No organizations found" });
                }
            });
        };
        const stage = process.env.NX_PUBLIC_STAGE;
        if (stage === "dev" || stage === "alpha")
            window.awsCognito = this;
        // Configure Amplify Auth
        Amplify.configure({
            Auth: {
                Cognito: {
                    userPoolId: this.configUserPoolId,
                    userPoolClientId: this.configClientId,
                },
            },
        });
    }
    get isLoggedIn() {
        return !!this.currentCognitoSession;
    }
    get userSub() {
        var _a;
        return (_a = this._cognitoEventClaims) === null || _a === void 0 ? void 0 : _a.sub;
    }
    get email() {
        return this.currentEmail;
    }
    get userMarketingMails() {
        var _a;
        return ((_a = this._cognitoEventClaims) === null || _a === void 0 ? void 0 : _a["custom:marketing"]) || false;
    }
    get userEditableDetails() {
        return Object.assign({}, this._userEditableDetails);
    }
    // #region Auth tokens info
    get sessionExpires() {
        var _a;
        const dtStr = (_a = this._cognitoEventClaims) === null || _a === void 0 ? void 0 : _a.exp;
        return dtStr ? new Date(dtStr) : null;
    }
    get idToken() {
        return this.jwtToken;
    }
    get accessToken() {
        return this.accessTokenInternal;
    }
    // #endregion
    // #region Current Organization data
    get currentOrganizationId() {
        var _a;
        return (_a = this._currentOrgSecurityData) === null || _a === void 0 ? void 0 : _a.orgId;
    }
    get currentOrgSecurityData() {
        return this._currentOrgSecurityData;
    }
    get orgAllowedDomains() {
        var _a;
        return (((_a = this._currentOrgSecurityData) === null || _a === void 0 ? void 0 : _a.domains) || "").split(",") || [];
    }
    get orgMfaForAllUsers() {
        var _a;
        return ((_a = this._currentOrgSecurityData) === null || _a === void 0 ? void 0 : _a.mfaAll) === "1" || false;
    }
    set orgMfaForAllUsers(v) {
        if (!this._currentOrgSecurityData)
            return;
        this._currentOrgSecurityData.mfaAll = v ? "1" : "0";
    }
    get isLoginInfoComplete() {
        return !!this._cognitoEventClaims;
    }
    get allOrganizationsInfo() {
        var _a;
        return ((_a = this._cognitoEventClaims) === null || _a === void 0 ? void 0 : _a.organizations) || [];
    }
    get allEffectiveOrganizationsInfo() {
        var _a;
        return (((_a = this._cognitoEventClaims) === null || _a === void 0 ? void 0 : _a.organizations.filter((o) => o.uEnabled === "1" && o.oEnabled === "1")) || []);
    }
    // #endregion
    // private get accountExpirationDate(): Date | undefined {
    //   const expiresAt =
    //     this._cognitoEventClaims?.orgAdminOptions?.subscription?.expiresAt;
    //   if (typeof expiresAt === "string") return new Date(expiresAt as string);
    //   else if (expiresAt) return expiresAt;
    //   return undefined;
    // }
    getEmail() {
        return this.currentEmail || "";
    }
    setUserSessionFromTokens(session) {
        var _a, _b, _c;
        const idToken = (_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken;
        if (idToken && this.isIdTokenValid(idToken)) {
            this.currentCognitoSession = session;
            this.currentEmail = idToken.payload.email;
            this.previousEmail = this.currentEmail;
            this.jwtToken = idToken.toString();
            this.accessTokenInternal = (_c = (_b = session.tokens) === null || _b === void 0 ? void 0 : _b.accessToken) === null || _c === void 0 ? void 0 : _c.toString();
            const okCb = this._onSuccess();
            okCb(session);
        }
        else {
            this.dispatchEvent(new CustomEvent("authenticationChanged", {
                detail: { isLoggedIn: false },
            }));
        }
    }
    isUsingFederatedIdentity() {
        var _a;
        const fedIdentities = ((_a = this._cognitoEventClaims) === null || _a === void 0 ? void 0 : _a.identities) || [];
        return fedIdentities.length > 0;
    }
    getRedirectFederationLoginUrl(federation) {
        if (!federation || !FEDERATION_PROVIDERS[federation])
            return "";
        const env = process.env.NX_PUBLIC_STAGE || "dev";
        const region = this.configUserPoolId.split("_")[0];
        const origin = window.location.origin;
        const url = [
            `https://tvd-users-api-tvd-stack-${env}.auth.${region}.amazoncognito.com/oauth2/authorize`,
            `?identity_provider=${FEDERATION_PROVIDERS[federation]}`,
            `&redirect_uri=${origin}`,
            `&response_type=CODE`,
            `&client_id=${this.configClientId}`,
            `&scope=email%20openid%20phone`,
        ].join("");
        return url;
    }
    /**
     * This is only used the first time the browser loads, to see if there is an existing valid session
     */
    checkIfUserIsLoggedIn() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            try {
                const session = yield fetchAuthSession();
                if (!session.tokens) {
                    this.clearSession(false);
                    return false;
                }
                this.currentCognitoSession = session;
                this.jwtToken = (_a = session.tokens.idToken) === null || _a === void 0 ? void 0 : _a.toString();
                this.accessTokenInternal = (_b = session.tokens.accessToken) === null || _b === void 0 ? void 0 : _b.toString();
                // Get user attributes
                const user = yield getCurrentUser();
                if (user) {
                    this.currentEmail = (_c = user.signInDetails) === null || _c === void 0 ? void 0 : _c.loginId;
                    this.previousEmail = this.currentEmail;
                }
                const proccessed = this.processCognitoSessionClaimsForFE(session.tokens.idToken);
                // getMfaOptions reads _cognitoEventClaims, which is populated by
                // processCognitoSessionClaimsForFE above. Calling it before would always
                // see undefined claims on a page refresh and skip the MFA check entirely.
                if (this._cognitoEventClaims && !this.isUsingFederatedIdentity())
                    this.getMfaOptions();
                if (proccessed === "OK") {
                    this.dispatchEvent(new CustomEvent("authenticationChanged", {
                        detail: { isLoggedIn: true },
                    }));
                    return true;
                }
                else if (proccessed === "FAIL") {
                    this.dispatchEvent(new CustomEvent("authenticationChanged", {
                        detail: { isLoggedIn: false },
                    }));
                    this.clearSession();
                    return false;
                }
                else {
                    this.dispatchEvent(new CustomEvent("authenticationChanged", {
                        detail: { isLoggedIn: true, error: "No organizations found" },
                    }));
                    return false;
                }
            }
            catch (error) {
                console.log("No session found", error);
                this.clearSession();
                this.dispatchEvent(new CustomEvent("authenticationChanged", {
                    detail: { isLoggedIn: false },
                }));
                return false;
            }
        });
    }
    /**
     * Authenticates a user in Cognito using Custom Auth flow without SRP
     * This sends username and code for authentication
     */
    authenticateUserWithCode(username, code) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            try {
                if (!username || !code) {
                    return { code: "loginMissingData" };
                }
                // Initiate custom auth flow without SRP
                const result = yield signIn({
                    username,
                    options: {
                        authFlowType: "CUSTOM_WITHOUT_SRP",
                    },
                });
                // If already signed in, process session
                if (result.isSignedIn) {
                    const session = yield fetchAuthSession();
                    const proccessed = this.processCognitoSessionClaimsForFE((_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken);
                    if (proccessed === "OK" || proccessed === "NO_ORGS") {
                        this.jwtToken = (_c = (_b = session.tokens) === null || _b === void 0 ? void 0 : _b.idToken) === null || _c === void 0 ? void 0 : _c.toString();
                        this.accessTokenInternal = (_e = (_d = session.tokens) === null || _d === void 0 ? void 0 : _d.accessToken) === null || _e === void 0 ? void 0 : _e.toString();
                        setPreferencesKeyAndValue("currentUsername", username);
                        this.currentEmail = username;
                        this.previousEmail = this.currentEmail;
                        this.currentCognitoSession = session;
                        this.dispatchEvent(new CustomEvent("authenticationChanged", {
                            detail: { isLoggedIn: true },
                        }));
                        if (proccessed === "OK") {
                            return {
                                code: "ok",
                                accessToken: this.accessTokenInternal,
                                idToken: this.jwtToken,
                            };
                        }
                        else {
                            return {
                                code: "failure",
                                error: { message: "No organizations found" },
                            };
                        }
                    }
                    else {
                        return {
                            code: "failure",
                            error: { message: "errors:incorrectUsernamePassword" },
                        };
                    }
                }
                // If challenge is required, confirm sign in with code
                if (result.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE") {
                    const confirmResult = yield confirmSignIn({
                        challengeResponse: code,
                    });
                    if (confirmResult.isSignedIn) {
                        const session = yield fetchAuthSession();
                        const proccessed = this.processCognitoSessionClaimsForFE((_f = session.tokens) === null || _f === void 0 ? void 0 : _f.idToken);
                        if (proccessed === "OK" || proccessed === "NO_ORGS") {
                            this.jwtToken = (_h = (_g = session.tokens) === null || _g === void 0 ? void 0 : _g.idToken) === null || _h === void 0 ? void 0 : _h.toString();
                            this.accessTokenInternal = (_k = (_j = session.tokens) === null || _j === void 0 ? void 0 : _j.accessToken) === null || _k === void 0 ? void 0 : _k.toString();
                            this.currentEmail = username;
                            this.previousEmail = this.currentEmail;
                            this.currentCognitoSession = session;
                            setPreferencesKeyAndValue("currentUsername", username);
                            this.dispatchEvent(new CustomEvent("authenticationChanged", {
                                detail: { isLoggedIn: true },
                            }));
                            if (proccessed === "OK") {
                                return {
                                    code: "ok",
                                    accessToken: this.accessTokenInternal,
                                    idToken: this.jwtToken,
                                };
                            }
                            else {
                                return {
                                    code: "failure",
                                    error: { message: "No organizations found" },
                                };
                            }
                        }
                        else {
                            return {
                                code: "failure",
                                error: { message: "errors:incorrectUsernamePassword" },
                            };
                        }
                    }
                    else {
                        return {
                            code: "customChallenge",
                        };
                    }
                }
                return {
                    code: "customChallenge",
                };
            }
            catch (error) {
                console.log("Custom auth failed", error);
                if (error && error.code === "UserLambdaValidationException") {
                    error.message = error.message.split("enabled=").pop().replace(/\.$/, "");
                }
                return { code: "failure", error };
            }
        });
    }
    /**
     * Authenticates a user in Cognito using Amplify Auth
     */
    authenticateUser(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            try {
                if (!username || !password) {
                    return { code: "loginMissingData" };
                }
                const result = yield signIn({ username, password });
                if (result.isSignedIn) {
                    const session = yield fetchAuthSession();
                    const proccessed = this.processCognitoSessionClaimsForFE((_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken);
                    if (proccessed === "OK" || proccessed === "NO_ORGS") {
                        this.jwtToken = (_c = (_b = session.tokens) === null || _b === void 0 ? void 0 : _b.idToken) === null || _c === void 0 ? void 0 : _c.toString();
                        this.accessTokenInternal = (_e = (_d = session.tokens) === null || _d === void 0 ? void 0 : _d.accessToken) === null || _e === void 0 ? void 0 : _e.toString();
                        this.currentEmail = username;
                        this.previousEmail = this.currentEmail;
                        this.currentCognitoSession = session;
                        this.dispatchEvent(new CustomEvent("authenticationChanged", {
                            detail: { isLoggedIn: true },
                        }));
                        if (proccessed === "OK") {
                            if (!this.isUsingFederatedIdentity())
                                this.getMfaOptions();
                            return {
                                code: "ok",
                                accessToken: this.accessTokenInternal,
                                idToken: this.jwtToken,
                            };
                        }
                        else {
                            return {
                                code: "failure",
                                error: { message: "No organizations found" },
                            };
                        }
                    }
                    else {
                        return {
                            code: "failure",
                            error: { message: "errors:incorrectUsernamePassword" },
                        };
                    }
                }
                else {
                    if (result.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
                        return { code: "newPasswordRequired", oldPassword: password };
                    }
                    else if (result.nextStep.signInStep === "RESET_PASSWORD") {
                        return { code: "resetPassword" };
                    }
                    else if (result.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE") {
                        return { code: "totpRequired" };
                    }
                    else if (result.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE") {
                        return { code: "customChallenge" };
                    }
                    else {
                        // NOTHING
                        this.setMfaFlagAsDisabled();
                        this.currentEmail = undefined;
                        this.previousEmail = this.currentEmail;
                        this.currentCognitoSession = undefined;
                        this.dispatchEvent(new CustomEvent("authenticationChanged", {
                            detail: { isLoggedIn: false },
                        }));
                        return {
                            code: "failure",
                            error: { message: "Failed to compose user data" },
                        };
                    }
                }
            }
            catch (error) {
                console.log("Authentication failed", error);
                if (error && error.code === "UserLambdaValidationException") {
                    error.message = error.message.split("enabled=").pop().replace(/\.$/, "");
                }
                return { code: "failure", error };
            }
        });
    }
    setNewPasswordFromForceChange(username, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            try {
                if (!username) {
                    throw { code: "notLoggedIn" };
                }
                const resp = yield confirmSignIn({ challengeResponse: newPassword });
                if (resp.isSignedIn) {
                    const session = yield fetchAuthSession();
                    this.currentCognitoSession = session;
                    this.jwtToken = (_b = (_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken) === null || _b === void 0 ? void 0 : _b.toString();
                    this.accessTokenInternal = (_d = (_c = session.tokens) === null || _c === void 0 ? void 0 : _c.accessToken) === null || _d === void 0 ? void 0 : _d.toString();
                    this.processCognitoSessionClaimsForFE((_e = session.tokens) === null || _e === void 0 ? void 0 : _e.idToken);
                    return {
                        code: "ok",
                        idToken: this.jwtToken,
                        accessToken: this.accessTokenInternal,
                    };
                }
                else {
                    throw resp.nextStep;
                }
            }
            catch (error) {
                return { code: "failure", error };
            }
        });
    }
    updateUserDetails(name, familyName, email, marketingMails = undefined) {
        if (!this._cognitoEventClaims)
            return;
        this._userEditableDetails.name = name;
        this._userEditableDetails.familyName = familyName;
        if (email)
            this._userEditableDetails.email = email;
        if (marketingMails !== undefined)
            this._cognitoEventClaims["custom:marketing"] = marketingMails;
    }
    isIdTokenValid(idTokenAccessor) {
        const isValid = !!idTokenAccessor && new Date((idTokenAccessor.payload.exp || 0) * 1000) > new Date();
        return isValid;
    }
    processCognitoSessionClaimsForFE(idTokenAccessor) {
        const isValid = this.isIdTokenValid(idTokenAccessor);
        const idTokenPayload = idTokenAccessor === null || idTokenAccessor === void 0 ? void 0 : idTokenAccessor.payload;
        if (!idTokenPayload || !isValid) {
            this._cognitoEventClaims = undefined;
            return "FAIL"; // -> Fast Return. No valid session
        }
        const cognitoClaimsForFE = parseCognitoClaimsForFe(idTokenPayload);
        this._cognitoEventClaims = cognitoClaimsForFE;
        this.tempAcceptsMarketingMails = undefined;
        this.updateUserDetails(cognitoClaimsForFE.name, cognitoClaimsForFE.family_name, cognitoClaimsForFE.email, undefined);
        const effectiveOrgs = cognitoClaimsForFE.organizations.filter((o) => o.uEnabled === "1" && o.oEnabled === "1");
        if (effectiveOrgs.length === 0) {
            return "NO_ORGS"; // -> Fast Return. No valid session
        }
        else if (effectiveOrgs.length === 1) {
            // Use effectiveOrgs (enabled orgs only), not the raw organizations list
            // which may place a disabled org first.
            const defaultOrgId = effectiveOrgs[0].orgId;
            this.changeCurrentOrganization(defaultOrgId);
        }
        else if (effectiveOrgs.length > 1) {
            const preferredOrgId = getPreferencesValue("preferredOrgId");
            if (preferredOrgId)
                this.changeCurrentOrganization(preferredOrgId);
        }
        goSquared.identify({
            email: cognitoClaimsForFE.email,
            name: `${cognitoClaimsForFE.name} ${cognitoClaimsForFE.family_name}`,
            marketingMailsConsent: this.tempAcceptsMarketingMails !== undefined
                ? this.tempAcceptsMarketingMails
                : cognitoClaimsForFE["custom:marketing"],
        });
        return "OK";
    }
    tryToRefreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            try {
                if (!this.currentCognitoSession || this.refreshTokenState === "refreshing") {
                    this.refreshTokenState = "idle";
                    return false;
                }
                this.refreshTokenState = "refreshing";
                const session = yield fetchAuthSession({ forceRefresh: true });
                if (session.tokens) {
                    this.currentCognitoSession = session;
                    this.jwtToken = (_a = session.tokens.idToken) === null || _a === void 0 ? void 0 : _a.toString();
                    this.accessTokenInternal = (_b = session.tokens.accessToken) === null || _b === void 0 ? void 0 : _b.toString();
                    this.processCognitoSessionClaimsForFE((_c = session.tokens) === null || _c === void 0 ? void 0 : _c.idToken);
                    console.log({
                        newsessionExpires: (_d = this.sessionExpires) === null || _d === void 0 ? void 0 : _d.toISOString(),
                    });
                    this.refreshTokenState = "idle";
                    return true;
                }
                else {
                    this.signOut();
                    this.refreshTokenState = "idle";
                    return false;
                }
            }
            catch (error) {
                this.signOut();
                this.refreshTokenState = "idle";
                return false;
            }
        });
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield signOut();
                this.clearSession();
                return true;
            }
            catch (error) {
                errorTracking.leaveBreadcrumb("Cognito signOut error", { error });
                this.clearSession();
                return true;
            }
        });
    }
    changePassword(username, oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield updatePassword({ oldPassword, newPassword });
                return undefined;
            }
            catch (error) {
                console.error("Change password error:", error);
                return error;
            }
        });
    }
    resetPassword(email) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const output = yield resetPassword({ username: email });
                return output;
            }
            catch (e) {
                return e;
            }
        });
    }
    confirmResetPassword(_a) {
        return __awaiter(this, arguments, void 0, function* ({ username, confirmationCode, newPassword, }) {
            try {
                yield confirmResetPassword({
                    username,
                    confirmationCode,
                    newPassword,
                });
            }
            catch (e) {
                return e;
            }
        });
    }
    clearSession(fullSignOut = true) {
        if (fullSignOut) {
            signOut().catch(console.error);
        }
        this.orgUsersBySub = undefined;
        this._cognitoEventClaims = undefined;
        this.currentCognitoSession = undefined;
        this.currentEmail = undefined;
        this._currentOrgSecurityData = undefined;
        errorTracking.leaveBreadcrumb("Cognito session cleared");
        goSquared.unIdentify();
        sessionStorage.clear();
        if (fullSignOut)
            setTimeout(() => {
                this.dispatchEvent(new CustomEvent("authenticationChanged", {
                    detail: { isLoggedIn: false },
                }));
                this.dispatchEvent(new CustomEvent("sessionTimedOut"));
            }, 50);
    }
    updateMFAPreferenceInCognito(enable) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield updateMFAPreference({ totp: enable ? "ENABLED" : "DISABLED" });
                return true;
            }
            catch (error) {
                console.log({ error });
                return false;
            }
        });
    }
    /** If the user is active, try to refresh the Tokens 20 minutes before the session ends */
    initiateRefreshToken() {
        var _a, _b;
        const MIN_REFRESH_TIME = 20 * 60 * 1000; // 20 minutes before session expires, try to refresh the token if criteria is met
        const isValid = this.isIdTokenValid((_b = (_a = this.currentCognitoSession) === null || _a === void 0 ? void 0 : _a.tokens) === null || _b === void 0 ? void 0 : _b.idToken);
        if (!isValid) {
            this.signOut();
            return;
        }
        const sessionTimesOutInMilliseconds = this.sessionExpires.getTime() - Date.now();
        const remaining = sessionTimesOutInMilliseconds - MIN_REFRESH_TIME;
        if (remaining > 0 || this.refreshTokenState === "refreshing") {
            return;
        }
        if (sessionTimesOutInMilliseconds < 0) {
            this.signOut();
            return;
        }
        this.tryToRefreshToken();
    }
    /** Update the name (temporarily) to show the correct Organization Name */
    updateOrganizationName(organizationName) {
        if (!this.currentOrgSecurityData)
            return;
        this.currentOrgSecurityData.name = organizationName;
    }
    /** Ask Cognito back-end and register MFA internally */
    getMfaOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                if (this.isUsingFederatedIdentity()) {
                    return Promise.resolve(false);
                }
                const mfaPrefs = yield fetchMFAPreference();
                if (mfaPrefs) {
                    this._mfaEnabled = mfaPrefs.preferred || ((_a = mfaPrefs.enabled) === null || _a === void 0 ? void 0 : _a[0]);
                }
                else {
                    this.setMfaFlagAsDisabled();
                }
            }
            catch (error) {
                console.log(error);
                this.dispatchEvent(new CustomEvent("sessionTimedOut"));
            }
        });
    }
}
/**
 * Singleton of TvdAwsCognito, an API to interact with Cognito Pool
 */
const awsCognito = new TvdAwsCognito();
export default awsCognito;
